import { Text, View } from '@react-pdf/renderer';

import { SELLER_ASSISTANCE_TYPE } from '@/config/constants';
import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const UnbeatableClause = ({ contract }: { contract: Contract }) => {
  return (
    <View>
      <Text style={styles.title}>Unbeatable Clause</Text>
      <Text style={styles.list}>
        <Text style={styles.listItem}>
          Unbeatable Loans LLC's platform provides a secure environment for both
          parties to amend and finalize the terms of this agreement.
        </Text>
        <Text style={styles.listItem}>
          Both parties agree <Text style={styles.DangerText}>$1,000</Text>{' '}
          contract negotiation fee is payable to Unbeatable Loans LLC as part of
          the Buyer's closing costs. This fee is due at the time of closing or
          via deposit. This agreement constitutes acknowledgment of the invoice.
        </Text>
        <Text style={styles.listItem}>
          Wiring Instructions for Unbeatable Loans LLC Fee are provided by
          Unbeatable Loans LLC. Please verify the instructions with your
          transaction manager before sending any funds.
        </Text>
        <Text style={styles.listItem}>
          This transaction will have a transaction manager assigned by
          Unbeatable Loans LLC to represent the interests of the Buyer. The
          transaction manager will be responsible for facilitating the
          negotiation process, ensuring compliance, and providing support
          throughout the transaction typically handled by a buyers agent.
        </Text>
        <Text style={styles.listItem}>
          The transaction manager will be available to answer any questions and
          provide assistance during the negotiation process. Please contact your
          transaction manager for any inquiries or concerns.
        </Text>
        <Text style={styles.listItem}>
          Both parties agree to the use of electronic signatures for the
          execution of this contract. Electronic signatures are legally binding
          and have the same force as handwritten signatures. By signing this
          agreement electronically, both parties acknowledge that they have
          read, understood, and agreed to the terms and conditions.
        </Text>
        <Text>
          {contract?.offerSpecifics?.sellerAssistanceType ===
          SELLER_ASSISTANCE_TYPE.SELLER_TO_PAY_BUYER_AGENT_FEE_ADDITIONAL_SELLER_CREDIT ? (
            <Text>
              Seller to credit{' '}
              <Text>{contract.offerSpecifics.buyerAgentCompensation}%</Text> of{' '}
              <Text>${contract.offerSpecifics.offerPrice}</Text> to buyer at
              closing, covering first the Unbeatable Loans LLC fee.
              Additionally, a seller credit of{' '}
              <Text>
                ${contract.offerSpecifics.sellerAssistanceClosingCosts}
              </Text>{' '}
              will be applied to closing costs, down payments, inspection fees,
              and other associated costs.
            </Text>
          ) : contract?.offerSpecifics?.sellerAssistanceType ===
            SELLER_ASSISTANCE_TYPE.SELLER_CREDIT_EQUALS_BUYER_AGENT_FEE ? (
            <Text>
              Seller to credit buyers agent compensation of{' '}
              <Text style={styles.DangerText}>
                {contract.offerSpecifics.buyerAgentCompensation}%
              </Text>{' '}
              of{' '}
              <Text style={styles.DangerText}>
                ${contract.offerSpecifics.offerPrice}
              </Text>{' '}
              to buyer at closing, covering first the Unbeatable Loans LLC fee,
              followed by other closing costs.
            </Text>
          ) : contract?.offerSpecifics?.sellerAssistanceType ===
            SELLER_ASSISTANCE_TYPE.SELLER_TO_PAY_UNBEATABLE_FEE ? (
            <Text style={styles.listItem}>
              Seller to credit <Text style={styles.DangerText}>$1,000</Text> of
              purchase price to buyer at closing, covering first the Unbeatable
              Loans LLC fee. Should this fee or any portion be waived at the
              discretion of Unbeatable Loans LLC, seller credit of{' '}
              <Text style={styles.DangerText}>$1,000</Text>
              will be applied to closing costs, down payments, inspection fees,
              and other associated costs.
            </Text>
          ) : (
            <Text style={styles.listItem}>
              <Text>
                Buyer will pay costs affiliated with the buyers side of the
                transaction, including the Unbeatable Loans LLC contract
                negotiation fee. There will ne no buyers agent commission.
              </Text>
            </Text>
          )}
        </Text>
      </Text>
    </View>
  );
};

export default UnbeatableClause;
